import React from "react";
import "./carding.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faLocationDot, faStar, faClock, faArrowRight, faTag } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
const Card = (props) => {
  return (
    <div className="card card-p">
      <div className="card-image">
        <img
          src={props.src}
          alt="Lake"
        />
      </div>

      <div className="card-content">
        <h2 className="card-title">{props.title}</h2>

        <div className="card-location">
          <FontAwesomeIcon icon={faLocationDot} />
          <span>{props.location}</span>
        </div>

        <div className="card-rating">
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <p>5.0</p>
        </div>
        <div className="card-footer">
          <div className="card-info">
            <span>
              <FontAwesomeIcon icon={faClock} /> {props.time} Trip
            </span>
          </div>

          <div className="card-price-section">
          <span>
              <FontAwesomeIcon icon={faTag} style={{transform:"rotate(90deg)"}} /> Starting From {props.rat}
            </span>
            <Link to={props.sr}><button className="card-btn">
              <FontAwesomeIcon icon={faArrowRight} />
            </button></Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;